// extracted by mini-css-extract-plugin
export default {"cell":"zu2pk","common-block":"pC3JA","common-block__title":"EdWns","common-block__list":"pSqNI","common-block__list-history":"GAekz","icon-close":"bCqYN","icon-close__image":"E2vmB"};